import { trackPage } from '../utils/analytics/main'

export const pageMixin = {
  computed: {
    pageName () {
      return this.$route.name
    }
  },
  mounted () {
    trackPage(this.pageName)
  }
}
